'use client';
import DropdownFilter, { FiltersType } from 'components/common/DropdownFilter';
import { DataIndexType, FiltersTimeline } from 'features/conge/types/timeline';
import useFetchData from 'hooks/useFetch';
import { t } from 'i18next';
import React, { Dispatch, SetStateAction } from 'react';
import { getSocieties, getTeams } from 'services/filtersService';

interface FilterTimelineProps {
  tempFilters: FiltersType;
  setTempFilters: Dispatch<SetStateAction<FiltersType>>;
  setTimeLineFilters: Dispatch<SetStateAction<FiltersTimeline>>;
  dataIndex?: DataIndexType | null;
  className: string;
}
const FilterTimeline: React.FC<FilterTimelineProps> = ({
  tempFilters,
  setTempFilters,
  setTimeLineFilters,
  dataIndex,
  className,
}) => {
  const { data: societies } = useFetchData(getSocieties, []);
  const { data: teams } = useFetchData(getTeams, []);
  const handleApply = (): void => {
    const filtersOption = tempFilters.filters;

    setTimeLineFilters((prevState) => ({
      ...prevState,
      filter: [
        {
          ...prevState.filter[0],
        },
        {
          ...prevState.filter[1],
          filterValue: Array.isArray(filtersOption?.departementIds)
            ? filtersOption.departementIds.join(',')
            : '',
        },
        {
          ...prevState.filter[2],
          filterValue: Array.isArray(filtersOption?.sitesIds)
            ? filtersOption.sitesIds.join(',')
            : '',
        },
        {
          ...prevState.filter[3],
          filterValue: Array.isArray(filtersOption?.functionIds)
            ? filtersOption.functionIds.join(',')
            : '',
        },
        {
          ...prevState.filter[4],
          filterValue: Array.isArray(filtersOption?.society)
            ? filtersOption.society.join(',')
            : '',
        },
        {
          ...prevState.filter[5],
          filterValue: Array.isArray(filtersOption?.team)
            ? filtersOption.team.join(',')
            : '',
        },
      ],
    }));
  };

  const handleUnapply = (): void => {
    setTempFilters({
      ...tempFilters,
      filters: {
        ...tempFilters.filters,
        departementIds: [],
        sitesIds: [],
        functionIds: [],
        society: [],
        team: [],
      },
    });
    setTimeLineFilters((prevState) => ({
      ...prevState,
      filter: prevState.filter.map((filter) => ({
        ...filter,
        filterValue: '',
      })),
    }));
  };

  if (!dataIndex) return;
  return (
    <>
      <div
        className={`minthr-flex minthr-flex-items-center minthr-bg-light-gray1 minthr-border-rounded minthr-p-4 minthr-mobile-flex-wrap calendar filters minthr-mobile-mb-4 ${className}`}
      >
        <DropdownFilter
          idPrefix="departementIds"
          label={t('filter.departement')}
          options={dataIndex.departements}
          selectedOptions={tempFilters.filters.functionIds}
          filters={tempFilters}
          setfilters={setTempFilters}
          className="minthr-dropdown-checklist-left"
        />
        <DropdownFilter
          idPrefix="sitesIds"
          label={t('filter.site')}
          options={dataIndex.sites}
          selectedOptions={tempFilters.filters.functionIds}
          filters={tempFilters}
          setfilters={setTempFilters}
          className="minthr-dropdown-checklist-right"
        />
        <DropdownFilter
          idPrefix="society"
          label={t('Society')}
          options={
            societies?.data.map((item) => ({
              label: item.text || '',
              value: item.value || '',
              title: item.text || '',
            })) || []
          }
          selectedOptions={tempFilters.filters.society}
          filters={tempFilters}
          setfilters={setTempFilters as Dispatch<SetStateAction<FiltersType>>}
          className="minthr-dropdown-checklist-left"
        />
        <DropdownFilter
          idPrefix="functionIds"
          label={t('filter.function')}
          options={dataIndex.functions}
          selectedOptions={tempFilters.filters.functionIds}
          filters={tempFilters}
          setfilters={setTempFilters}
          className="minthr-dropdown-checklist-right"
        />
        <DropdownFilter
          idPrefix="team"
          label={t('Service')}
          options={
            (teams &&
              teams?.data.map((item) => ({
                label: item.text || '',
                value: item.value || '',
                title: item.text || '',
              }))) ||
            []
          }
          selectedOptions={tempFilters.filters.site}
          filters={tempFilters}
          setfilters={setTempFilters as Dispatch<SetStateAction<FiltersType>>}
          className="minthr-dropdown-checklist-left"
        />
        <a
          onClick={handleApply}
          className="minthr-btn minthr-btn-s minthr-btn-primary minthr-mobile-m-0 text-s minthr-px-4 minthr-mobile-w-80 minthr-ml-auto minthr-mobile-mx-2"
        >
          {t('Apply')}
        </a>
        <a
          className="minthr-btn minthr-btn-s minthr-btn-outline minthr-btn-light-gray2 minthr-mobile-mr-2 p-0 minthr-ml-3 minthr-mobile-ml-auto"
          onClick={handleUnapply}
        >
          <img className="minthr-icon-danger" src="/icons/delete.svg" alt="" />
        </a>
      </div>
    </>
  );
};

export default FilterTimeline;
